<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>学生跟进</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="80px" size="small" class="query-form"
        @submit.native.prevent="getList()">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词" style="width:215px;"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.state" filterable clearable @change="stateClick()">
            <el-option v-for="item in statelist" :label="item.name" :value="item.id" :key="item.id"
              placeholder="请选择"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划赴日">
          <el-select v-model="query.abroadPlan" filterable clearable @change="schoolClick()">
            <el-option label="请选择" value></el-option>
            <el-option v-for="item in planList" :label="item" :value="item" :key="item" placeholder="请选择"></el-option>
          </el-select>
        </el-form-item>

        <div>
          <el-form-item label="学校">
            <el-select v-model="query.schid" filterable clearable @change="schoolClick()">
              <el-option label="请选择" value></el-option>
              <el-option v-for="item in schoollist" :label="item.label" :value="item.value" :key="item.value"
                placeholder="请选择"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学历">
            <el-select v-model="query.edu" filterable  clearable @change="schoolClick()">
              <el-option label="请选择" value></el-option>
              <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"
                placeholder="请选择"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源">
            <el-cascader :options="sourselist" v-model="selectedOrigion" clearable change-on-select
              :props="{ value: 'name', label: 'name', checkStrictly: true }" style="width: 100%"
              @change="stateClick"></el-cascader>
          </el-form-item>
        </div>

        <div>
          <el-form-item label="顾问">
            <DeptRoleTeacherSelect v-model="query.adviserID" dept="留学" placeholder="请选择部门 → 角色 → 老师" @change="schoolClick()" />
          </el-form-item>
          <el-form-item label="营销">
            <DeptRoleTeacherSelect v-model="query.marketID" dept="留学" placeholder="请选择部门 → 角色 → 老师" @change="schoolClick()" />
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="学生/家长">
            <el-select v-model="query.studentType" placeholder="全部" clearable filterable @change="schoolClick()">
              <el-option v-for="item in studentTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别">
            <el-select v-model="query.sex" placeholder="全部" clearable filterable @change="schoolClick()">
              <el-option label="男" :value="true"></el-option>
              <el-option label="女" :value="false"></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="日语状况" label-width="80px" >
              <el-select v-model="query.japanese" filterable clearable @change="schoolClick()">
                <el-option v-for="item in japlist" :label="item.name" :value="item.id" :key="item.id"
                 placeholder="请选择等级"></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="赴日目的" label-width="80px">
            <el-select v-model="query.purpose" clearable filterable placeholder="请选择" @change="selList()">
              <el-option v-for="item in purposeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄阶段" label-width="80px">
            <el-select v-model="query.ageRange" clearable placeholder="请选择" @change="selList()">
              <el-option v-for="item in ageRangeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="添加时间">
            <el-date-picker v-model="query.daterange" clearable @change="schoolClick()" value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="selList()">查询</el-button>
            <!-- <el-button type="success" @click="addClick()">新增</el-button> -->
            <el-button type="success" @click="exportClick()">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>学生列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%"
          :row-class-name="tableRowClassName">
          
          <el-table-column prop="inputTime" label="添加时间"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="age" label="年龄"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <el-table-column prop="abroadPlan" label="计划赴日"></el-table-column>
          <el-table-column prop="adviserName" label="顾问"></el-table-column>
          <el-table-column prop="marketName" label="营销"></el-table-column>
          <el-table-column label="来源">
            <template slot-scope="scope">
              <span :title="scope.row.origin">{{ scope.row.origin }}</span>
              <span :title="scope.row.recName">{{ scope.row.recName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="状态"></el-table-column>
          <el-table-column label="地址">
            <template slot-scope="scope">
              <span :title="scope.row.zzProvinceName">{{ scope.row.zzProvinceName }}</span>
              <span :title="scope.row.zzCityName">{{ scope.row.zzCityName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="followSummaryCombined" label="目前状况" min-width="140" width="200" class-name="follow-combined-cell">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 'e'" class="cell-wrap-pre" :title="scope.row.reason">{{ scope.row.reason }}</span>
              <span v-else class="cell-wrap-pre" :title="scope.row.followSummaryCombined || scope.row.followSummary">{{ scope.row.followSummaryCombined || scope.row.followSummary || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="学生/家长" width="90">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="(scope.row.studentType || scope.row.StudentType) === '家长'">家长</el-tag>
              <el-tag type="warning" v-else-if="(scope.row.studentType || scope.row.StudentType) === '学生'">学生</el-tag>
              <span v-else>{{ scope.row.studentType || scope.row.StudentType || '—' }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.sex == true">男</el-tag>
              <el-tag type="warning" v-else>女</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="japanese" label="日语"></el-table-column> -->
          <!-- 留学=primary 日语=success 鸣野=warning；统一命名与颜色 -->
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-student="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <el-table-column label="回访1" width="100">
            <template slot-scope="scope">
              <span class="link-like" @click="showVisitDetail(scope.row, 1)">{{ hasVisit1(scope.row) ? '已回访' : '未回访' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="回访2" width="100">
            <template slot-scope="scope">
              <span class="link-like" @click="showVisitDetail(scope.row, 2)">{{ hasVisit2(scope.row) ? '已回访' : '未回访' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="isMarketingOnlyStu(scope.row) || isNoAdviserStu(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.id"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.id"></el-button>
                </el-tooltip>
                <el-tooltip content="评估表" placement="top">
                  <el-button type="warning" size="mini" icon="el-icon-notebook-2"
                    @click="tabClick(scope.row.id)"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditStu(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid" @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
                <!-- <el-tooltip content="跟进详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-user"
                    @click="openFollow(scope.row.id)"></el-button>
                </el-tooltip> -->
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog :title="form.id > 0 ? '编辑学生信息' : '添加学生信息'" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="添加时间" prop="inputTime" :rules="[{ required: true, message: '请填写日期' }]">
              <el-date-picker v-model="form.inputTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="姓名" prop="realName" :rules="[{ required: true, message: '请输入姓名' }]">
              <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="性别" prop="sex" :rules="[{ required: true, message: '请输选择性别' }]">
              <el-radio-group v-model="form.sex">
                <el-radio :label="true">男</el-radio>
                <el-radio :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="跟进状态" prop="state" :rules="[{ required: true, message: '请选择跟进状态' }]">
              <el-select v-model="form.state" placeholder="请选择跟进状态" filterable>
                <el-option v-for="item in statelist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="来源" prop="origin">
              <el-select v-model="form.origin" placeholder="请选择来源" clearable filterable @change="changeReouce">
                <el-option v-for="item in sourselist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="form.state == 'e'">
          <el-col :span="10">
            <el-form-item label="淘汰原因" prop="reason" :rules="[{ required: true, message: '请选择淘汰原因' }]">
              <el-select v-model="form.reason" placeholder="请选择淘汰原因" filterable>
                <el-option v-for="item in reasonlist" :label="item.name" :value="item.name" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="退出费用" prop="exitAmount" v-if="form.state == 'f'">
          <el-input v-model.number="form.exitAmount" type="number" placeholder="请输入数字"></el-input>
        </el-form-item>

        <el-form-item label="来源备注" prop="originRemark" v-if="form.origin == '线下市场' || form.origin == '其他'">
          <el-input v-model="form.originRemark" placeholder="请输入来源备注"></el-input>
        </el-form-item>
        <el-form-item label="推荐人" prop="recName" v-if="form.origin == '留学组推荐' || form.origin == '日语组推荐'">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable>
            <el-option v-for="item in adviserList" :label="item.realName" :value="item.realName"
              :key="item.userID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="labelorgin" prop="recName" v-if="ischildren">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable>
            <el-option v-for="item in tiktoklist" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作方推荐" prop="recName" v-if="form.origin == '合作方推荐'">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable>
            <el-option v-for="item in partlist" :label="item.title" :value="item.title" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="学历" prop="eduBack" :rules="[{ required: true, message: '请选择学历' }]">
              <el-select v-model="form.eduBack" placeholder="请选择学历" filterable>
                <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="10" v-if="form.id > 0">
            <el-form-item label="计划赴日" prop="abroadPlan" :rules="[{ required: true, message: '请选择计划赴日时间' }]">
              <el-select v-model="form.abroadPlan" placeholder="请选择时间" filterable>
                <el-option v-for="item in planList" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-else>
            <el-form-item label="计划赴日" prop="abroadPlan" :rules="[{ required: true, message: '请选择计划赴日时间' }]">
              <el-select v-model="form.abroadPlan" placeholder="请选择时间" filterable>
                <el-option v-for="item in planList2" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>   


        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="留学目的" prop="purpose">
              <el-select v-model="form.purpose" placeholder="请选择" clearable filterable style="width: 100%">
                <el-option v-for="item in purposeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="微信" prop="wechat">
              <el-input v-model="form.wechat" placeholder="请输入微信号" @change="wechatChange" @blur="wechatChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学生/家长" prop="studentType">
              <el-select v-model="form.studentType" placeholder="请选择" filterable clearable style="width: 100%">
                <el-option v-for="item in studentTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="QQ" prop="qq">
              <el-input v-model="form.qq" placeholder="请输入QQ"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-alert type="warning" style="position: relative; top: -10px" v-if="form.wechatCheck">{{ form.wechatCheck
          }}</el-alert>
        <el-row :gutter="20">

          <el-col :span="10">
            <el-form-item label="电话" prop="mobile">
              <el-input v-model.number="form.mobile" type="number" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="年龄" prop="age">
              <el-input v-model.number="form.age" type="number" placeholder="请输入年龄"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="现住地址">
          <el-cascader :options="areaList" :props="{ label: 'label', value: 'label' }" v-model="selectedOptions"
            style="width: 100%" clearable></el-cascader>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="日语" prop="japaneseBase">
              <el-select v-model="form.japaneseBase" placeholder="请选择日语等级" filterable>
                <el-option v-for="item in japlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="英语" prop="english">
              <!-- <el-select v-model="form.english" placeholder="请选择英语等级" filterable>
                <el-option v-for="item in enlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select> -->
              <el-input v-model="form.english" placeholder="请输入英语等级"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="目前状况" prop="followSummary" :rules="[{ required: false, message: '请输入目前状况' }]">
          <el-input v-model="form.followSummary" placeholder="请输入目前跟进状况"></el-input>
        </el-form-item>

        <div>
          <el-divider content-position="left" style="padding: 10px 0px">修改顾问/营销/文案老师</el-divider>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="顾问老师" prop="adviserID" :rules="[{ required: true, message: '请选择' }]">
                <DeptRoleTeacherSelect v-model="form.adviserID" dept="留学" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营销老师" prop="marketID">
                <DeptRoleTeacherSelect v-model="form.marketID" dept="留学" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文案老师" prop="documentID">
                <el-select v-model="form.documentID" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in documentList" :label="item.realName" :value="item.userID"
                    :key="item.userID"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 操作对话框 -->
    <el-dialog title="评估表信息" :visible.sync="evalDialogVisible">
      <el-form :model="eval" label-width="100px" :status-icon="true">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>语言学校评估表</span>
            <a :href="eval.link" target="_blank">
              <el-link type="link" style="float: right">打开链接</el-link>
            </a>
          </div>
          <div>
            <el-form-item label="完善地址" prop="link" :rules="[{ required: true, message: '请输入姓名' }]">
              <el-input v-model="eval.link"></el-input>
            </el-form-item>

            <el-form-item>
              <!-- <a :href="'/vue/assess?id=' + eval.stuid" target="_blank">
                <el-button type="primary">内部完善资料</el-button>
              </a> -->
            </el-form-item>
            <!-- <hr> -->
            <el-form-item label="评估表" v-if="eval.isDown">
              <a target="_blank" :href="domain + eval.downLink">
                <el-button type="success">点击生成word</el-button>
              </a>
            </el-form-item>
            <el-alert title="完善评估表资料后即可下载！" type="warning" v-else></el-alert>
          </div>
        </el-card>
        <div style="height: 20px"></div>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>研究生评估表</span>

            <a :href="evalGra.link" target="_blank">
              <el-link type="link" style="float: right">打开链接</el-link>
            </a>
          </div>

          <div>
            <el-form-item label="完善地址">
              <el-input v-model="evalGra.link"></el-input>
            </el-form-item>

            <!-- <hr> -->
            <el-form-item label="评估表" v-if="evalGra.isDown">
              <a target="_blank" :href="domain + evalGra.downLink">
                <el-button type="success">点击生成word</el-button>
              </a>
            </el-form-item>
            <el-alert title="完善评估表资料后即可下载！" type="warning" v-else></el-alert>
          </div>
        </el-card>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="evalDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 其他部门跟进详情弹窗（统一组件） -->
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <!-- 分配弹框（统一组件） -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserList"
      :market-list="marketList"
      :user-is-admain="userIsAdmain"
      :show-student="false"
      :show-jap="true"
      :show-mingye="true"
      empty-message="请选择分配给日语或鸣野"
      @success="getList"
    />

    <VisitDetailDialog
      :visible.sync="visitDetailVisible"
      :row="visitDetailRow"
      :which-visit="visitDetailWhich"
      follow-type="student"
      @success="getList"
      @closed="onVisitDetailClosed"
    />

    <StudentShow :stuid="showstuid" v-on:setzero="showstuid = 0"></StudentShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import StudentShow from "@/components/StudentShow";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import VisitDetailDialog from "@/components/VisitDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
export default {
  name: 'common',
  data() {
    return {
      domain: url.getDomain(),
      userIsAdmain: user.isAdmin(), //是否是管理员
      userIsMarket: user.isMarket(), //是否是营销
      userIsAdviser: user.isAdviser(), //是否是顾问
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      evalDialogVisible: false,
      eval: {}, //完善地址，下载地址
      evalGra: {}, //研究生，下载地址
      submiting: false,
      stuid: 0,
      areaList: [], //地区
      selectedOptions: [],
      adviserList: [],
      documentList: [],
      marketList: [],
      planList: url.getAbroadYear(), //计划赴日时间
      assignDialogVisible: false, //分配对话框显示
      assignForm: {
        resourceTypes: [] // 分配的资源类型：['日语', '鸣野']
      }, //分配表单
      assignSubmiting: false, //分配提交中
      visitDetailVisible: false,
      visitDetailRow: null,
      visitDetailWhich: 1,
      followDialogVisible: false,
      followDialogRow: null,
      followDialogLoading: false,
      followType: '',
      followData: { list: [] },
      followJapHasCourse: false,
      followMingyeDetail: null,
      followDialogTitle: '',
      sourselist: [], //来源
      edubacklist: url.getEduBack(), //学历
      purposeList: url.getStudentPurposeList(), // 赴日目的（筛选用）
      ageRangeList: url.getAgeRangeList(), // 年龄阶段（筛选用）
      japlist: url.getJapLevelListForStu(), // 日语水平（统一数据）
      studentTypeList: url.getStudentTypeList(), // 学生/家长（筛选用）
      enlist: [
        { id: "好", name: "好" },
        { id: "一般", name: "一般" },
        { id: "差", name: "差" },
        { id: "有托福托业成绩", name: "有托福托业成绩" },
      ], //英语水平
      statelist: url.getStateData(), //跟进状态
      schoollist: [], //获取学校
      showstuid: 0,
      reasonlist: [
        { id: "不回复", name: "不回复" },
        { id: "资金问题", name: "资金问题" },
        { id: "家长不同意", name: "家长不同意" },
        { id: "找其他中介", name: "找其他中介" },
        { id: "非本地中介", name: "非本地中介" },
        { id: "心理健康", name: "心理健康" },
        { id: "生理健康", name: "生理健康" },
        { id: "其他原因", name: "其他原因" },
      ], //淘汰原因
      tiktoklist: [
        { id: 1, name: "直播" },
        { id: 2, name: "短视频" },
      ], //抖音推荐
      partlist: [], //合作方推荐
      selectedOrigion: [],
      data: [
        { id: "知乎", name: "知乎", children: [{ id: "直播", name: "直播" }, { id: "短视频", name: "短视频" }] },
        { id: "微博", name: "微博", children: [{ id: "直播", name: "直播" }, { id: "短视频", name: "短视频" }] },
        { id: "官网评估咨询", name: "官网评估咨询", children: [{ id: "直播", name: "直播" }, { id: "短视频", name: "短视频" }] },
        { id: "公众号", name: "公众号", children: [{ id: "直播", name: "直播" }, { id: "短视频", name: "短视频" }] },
        { id: "B站", name: "B站", children: [{ id: "直播", name: "直播" }, { id: "短视频", name: "短视频" }] },
        { id: "抖音", name: "抖音", children: [{ id: "直播", name: "直播" }, { id: "短视频", name: "短视频" }] },
      ],
      planList2: url.getAbroadYear(), // 新增时计划赴日（与 planList 一致，从当前年起）
      sourselist2: [],
      ischildren: false,
      labelorgin: '',
      isMkt: false,
    };
  },
  components: {
    StudentShow,
    OtherDeptFollow,
    FollowDetailDialog,
    VisitDetailDialog,
    AssignResourceDialog,
    DeptRoleTeacherSelect,
  },
  methods: {
    openFollow(id) {
      if (id && typeof window !== 'undefined' && window.open) {
        window.open('/vue/follow?id=' + id, '_blank');
      }
    },
    hasVisit1(row) {
      if (!row) return false;
      const d = row.visit1Date || row.Visit1Date;
      const s = row.visit1Subject || row.Visit1Subject;
      const sum = row.visit1Summary != null ? row.visit1Summary : (row.Visit1Summary != null ? row.Visit1Summary : '');
      return (d != null && d !== '') || (s != null && String(s).trim() !== '') || (sum != null && String(sum).trim() !== '');
    },
    hasVisit2(row) {
      if (!row) return false;
      const d = row.visit2Date || row.Visit2Date;
      const s = row.visit2Subject || row.Visit2Subject;
      const sum = row.visit2Summary != null ? row.visit2Summary : (row.Visit2Summary != null ? row.Visit2Summary : '');
      return (d != null && d !== '') || (s != null && String(s).trim() !== '') || (sum != null && String(sum).trim() !== '');
    },
    showVisitDetail(row, whichVisit) {
      this.visitDetailRow = row;
      this.visitDetailWhich = whichVisit === 2 ? 2 : 1;
      this.visitDetailVisible = true;
    },
    onVisitDetailClosed() {
      this.visitDetailRow = null;
      this.visitDetailWhich = 1;
      this.loading = false;
    },
    canEditStu(row) {
      return user.canEditStu(row);
    },
    isMarketingOnlyStu(row) {
      return user.isMarketingOnlyStu(row);
    },
    isNoAdviserStu(row) {
      return user.isNoAdviserStu(row);
    },
    //行样式
    tableRowClassName({ row, rowIndex }) {
      if (row.state === "c") {
        return "success-row";
      } else if (row.state === "e") {
        return "info-row";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    // 获取合作方
    getAllPart() {
      var _this = this;
      var link = url.getStu("GetAllPartner");
      $.get(link, {}, (data) => {
        _this.partlist = data;
      });
    },
    // 获取淘汰原因
    getER() {
      var _this = this;
      var link = url.getER("ERIdName");
      $.get(link, {}, (data) => {
        _this.reasonlist = data;
      });
    },
    // 来源
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist = data.originParam;

      });
    },
    //new来源2
    getAllOrigin2() {
      var _this = this;
      function convertStringToObject(str) {
        if (!str) {
          return [];
        }

        var dataArray = str.split(',');
        var categories = [];
        var currentIndex = 1;
        dataArray.forEach(function (item) {
          var subcategories = item.split('-');

          if (subcategories.length === 1) {
            var category = subcategories[0].trim();
            categories.push({ id: currentIndex, name: category });
            currentIndex++;
          } else {
            var mainCategory = subcategories[0].trim();
            var subcategoryNames = subcategories.slice(1).join('-').split('-').map(sub => sub.trim()).filter(sub => sub);
            var children = [];

            subcategoryNames.forEach(function (subName, index) {
              children.push({ id: index + 1, name: subName });
            });

            if (children.length > 0) {
              categories.push({ id: currentIndex, name: mainCategory, children: children });
              currentIndex++;
            }
          }
        });
        return categories;
      }
      var link = url.getSys("GetConfig");
      $.get(link, {}, (data) => {

        var list = data.keys.split(',');
        var list2 = list.map((item, index) => {
          return {
            id: index + 1,
            name: item
          }
        })
        _this.sourselist2 = list2;
      });
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.inputStart = _this.query.daterange[0];
        params.inputEnd = _this.query.daterange[1];
      } else {
        params.inputStart = "";
        params.inputEnd = "";
      }
      if (_this.selectedOrigion.length > 0) {
        params.origin = _this.selectedOrigion[0];
        params.recName = _this.selectedOrigion[1];
      } else {
        params.origin = "";
        params.recName = "";
      }
      // 2026-01升级：留学列表只显示留学资源（IsStudent = true）
      params.isStudent = true;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getStu("getlist_base");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //按状态查询
    stateClick: function () {
      this.getList();
    },
    //获取学校
    school: function () {
      var _this = this;
      var link = url.getCommon("getschool");
      $.get(link, {}, (data) => {
        _this.schoollist = data;
      });
    },
    //按学校查询
    schoolClick: function () {
      this.getList();
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },

    //获取地区数据
    getArea() {
      var _this = this;
      var link = url.getCommon("getareatwo");
      $.getJSON(link, (data) => {
        _this.areaList = data;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getStu("addorupdate_base");
      var info = this.form;
      info.recName = this.form.recName;
      if (this.selectedOptions) {
        info.zzProvinceName = this.selectedOptions[0];
        info.zzCityName = this.selectedOptions[1];
      } else {
        info.zzProvinceName = "";
        info.zzCityName = "";
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //洗澡能
    addClick: function () {
      this.dialogVisible = true;
      var now = new Date();
      var today =
        now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
      //表单重置
      this.form = {
        sex: true,
        inputTime: today,
        isAbove: true,
      };
      //地区选择重置
      this.selectedOptions = [];
    },
    changeReouce(val) {
      var origin = this.form.origin;
      this.labelorgin = origin;

      const index = this.sourselist.findIndex(item => item.id === val);
      //  console.log(this.sourselist[index].children);
      if (this.sourselist[index].children == null) {
        this.ischildren = false
        return false;
      }
      var children = this.sourselist[index].children;
      if (children.length >= 1) {
        this.tiktoklist = children;
        this.ischildren = true;

      } else {
        this.ischildren = false
      }
    },
    //编辑
    editClick: function (row) {
      console.log("row:", row);
      var isMarket = this.userIsMarket;
      if (isMarket) {
        this.isMkt = true
      }
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
      this.changeReouce(this.form.origin);

      this.selectedOptions = [row.zzProvinceName, row.zzCityName];
    },
    //跳转评估表
    tabClick: function (id) {
      var _this = this;
      _this.evalDialogVisible = true;
      var link = url.getStu("getlink");
      $.get(link, { id: id }, (data) => {
        _this.eval = data;
      });

      var link2 = url.getStu("Get_GraLink");
      $.get(link2, { id: id }, (data) => {
        _this.evalGra = data;
      });
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getStu("delete_base"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { idList: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //导出操作
    exportClick() {
      var _this = this;
      var params = _this.query;
      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      result.push("exportName=学生跟进列表");
      var link = url.getStu("ExportVip") + "?" + result.join("&");
      //console.info(link);
      window.open(link, "_blank");
    },
    //微信验证（编辑时传 excludeId 排除当前记录，避免用自己的微信号也提示“已添加”）
    wechatChange() {
      var _this = this;
      var wechat = this.form.wechat;
      if (wechat) {
        var link = url.getStu("CheckWechat");
        var params = { wechat: wechat };
        if (this.form.id > 0) params.excludeId = this.form.id;
        $.get(link, params, (res) => {
          _this.$set(_this.form, "wechatCheck", res);
        });
      }
    },
    // 分配
    assignClick: function(row) {
      var _this = this;
      var currentUserID = user.getInfo() && (user.getInfo().userID != null ? user.getInfo().userID : user.getInfo().Id);
      _this.assignForm = {
        id: row.id,
        studentID: row.id,
        realName: row.realName,
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: row.isMingye || false,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: _this.userIsAdmain ? (row.marketID || null) : (currentUserID || null),
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: _this.userIsAdmain ? (row.jpMarketID || null) : (currentUserID || null),
        myAdviserID: row.myAdviserID || null,
        myMarketID: _this.userIsAdmain ? (row.myMarketID || null) : (currentUserID || null)
      };
      _this.assignDialogVisible = true;
    },
    showFollowDialog: function(type, row) {
      this.followType = type;
      this.followDialogRow = row || {};
      this.followDialogVisible = true;
    },
    viewJapFollow: function(studentID) {
      if (studentID) window.open('/vue/japfollow?id=' + studentID, '_blank');
    },
    viewMingyeFollow: function(studentID) {
      if (studentID) window.open('/vue/mingyefollow?id=' + studentID, '_blank');
    },
    getStateName: function(state) {
      return state ? '跟进中' : '待分配';
    },
  },
  created() {
    this.getAllOrigin2();

  },
  mounted() {
    // console.info(url.getOriginData());
    var _this = this;
    //参数处理
    _this.query = _this.$route.query;
    // 来源
    _this.getAllOrigin();
    //获取合作方
    _this.getAllPart();
    //获取淘汰原因
    _this.getER();
    //获取学生列表
    this.getList();
    //获取地区
    this.getArea();
    //获取学校
    this.school();
    // 顾问/营销老师：不再按板块获取，直接获取所有启用用户
    $.get(url.getStu("getenableusers"), (res) => {
      var list = res || [];
      _this.adviserList = list;
      _this.marketList = list;
    });
    $.get(url.getStu("getdocument"), (res) => {
      _this.documentList = res;
    });
  },
};
</script>
<style scoped>
.link-like { color: #409EFF; cursor: pointer; }
.link-like:hover { text-decoration: underline; }
.visit-block { margin-bottom: 16px; }
.visit-block .visit-label { font-weight: bold; margin-bottom: 8px; color: #303133; }
.visit-block div { margin-bottom: 4px; }
/* 目前状况列：自动换行，原跟进+回访1+回访2 各自换行 */
.cell-wrap-pre { white-space: pre-line; word-break: break-word; }
::v-deep .follow-combined-cell .cell { white-space: pre-line !important; word-break: break-word; }
.follow-detail-block div { margin-bottom: 10px; line-height: 1.6; }
</style>